module.exports = __webpack_public_path__ + "img/markin_dark.964cbc0d.png";